// extracted by mini-css-extract-plugin
export default {"back":"PokedexEntry_back__1j3qc"};